enum StatisticIndicatorValueType {

    LEVEL = "level",

    NUMBER = "number",

    PERCENTAGE = "percentage"
}

export default StatisticIndicatorValueType;